import React, { useState } from 'react';
import Filters from '../../../components/Filter';
import FilterInput from '../../../components/Filter/components/FilterInput';
import { translate } from '../../../services/translate';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import { CamerasParamList } from '../../../typings/Params';
import CameraTagsDropdown from '../../../components/Filters/Cameras/CameraTagsDropdown';

interface Props {
    filters: CamerasParamList['AlertGroups'];
    setFilters: React.Dispatch<React.SetStateAction<CamerasParamList['AlertGroups']>>;
    textFilter: string;
    setTextFilter: React.Dispatch<React.SetStateAction<string>>;
}

function Filter({ filters, setFilters, textFilter, setTextFilter }: Props) {
    const navigation = useNavigation<NavigationProp<RouteProp<CamerasParamList, 'AlertGroups'>>>();
    const [selectedTagsFilter, setSelectedTagsFilter] = useState<number[]>(filters.cameraTagIds ?? []);

    const handleCleanFilter = () => {
        setTextFilter('');
        setSelectedTagsFilter([]);
    };

    const handleFilter = () => {
        navigation.setParams({
            ...filters,
            page: 1,
            textFilter: textFilter !== '' ? textFilter : undefined,
            cameraTagIds: selectedTagsFilter.length ? selectedTagsFilter : undefined,
        });

        setFilters({
            ...filters,
            page: 0,
            textFilter: textFilter !== '' ? textFilter : undefined,
            cameraTagIds: selectedTagsFilter.length ? selectedTagsFilter : undefined,
        });
    };

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <FilterInput
                label={translate('typeToSearch')}
                value={textFilter}
                placeholder={translate('typeToSearch')}
                onChange={setTextFilter}
            />
            <CameraTagsDropdown
                value={selectedTagsFilter}
                setValue={setSelectedTagsFilter}
                zIndex={2}
                label='cameraTags'
            />

        </Filters>
    );
}

export default Filter;
